import { useEffect, useState } from "react";
import { useLanguage, LOGO_URL, COMPANY } from "@/i18n";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Header = () => {
  const { t, lang, toggle } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "services", label: t.nav.services },
    { id: "about", label: t.nav.about },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-white/75 border-b border-slate-200/60 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => scrollTo("hero")}
          className="flex items-center gap-3 group"
          aria-label={COMPANY.shortName}
        >
          <img src={LOGO_URL} alt="Modern Communication Systems" className="h-11 w-auto object-contain" />
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollTo(l.id)}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="lang-toggle-button"
          onClick={toggle}
          className="text-xs font-bold uppercase tracking-[0.2em] px-3.5 py-2 rounded-md border border-slate-200 bg-white/60 text-slate-700 hover:bg-slate-100 hover:text-slate-900 transition-all"
        >
          {lang === "pl" ? "EN" : "PL"}
        </button>
      </div>
    </header>
  );
};
